// extracted by mini-css-extract-plugin
export default {"button":"U7kn1QNP9eP9JcS03nBH","double":"tcQMGXmIe_uRiQ8ZYOm8","placeHolderShimmer":"dSqT6qUZgizRVuvd9fFQ"};